import React, { Component } from "react";
import Paper from "material-ui-next/Paper";
import Typography from "material-ui-next/Typography";
import { Row, Col } from "react-flexbox-grid";
import { TextField, SelectField, Loadable } from "components/support";

class FilterView extends Component {
  static status = [
    { value: "all", label: "Todos" },
    { value: true, label: "Ativos" },
    { value: false, label: "Inativos" }
  ];

  static types = [
    { value: "all", label: "Todos" },
    { value: "variable_percentual", label: "Percentual Variável" },
    { value: "fixed_percentage", label: "Percentual Fixo" },
    { value: "fixed_value", label: "Valor Fixo" },
    { value: "variable_value", label: "Valor Variável" }
  ];

  state = {
    name: "",
    type: "all",
    enabled: "true"
  };

  handleField = (field, value) => {
    const { onFilter } = this.props;
    this.setState({ [field]: value }, () => onFilter(this.state));
  };

  render() {
    const { loading } = this.props;
    const { description, type, enabled } = this.state;

    return (
      <Paper elevation={1} className="p-sm mb-md">
        <Loadable loading={loading}>
          <Typography type="headline">Filtros</Typography>
          <Row>
            <Col xs={12} md>
              <TextField
                allowClear
                fullWidth
                label="Descrição"
                value={description}
                onChange={(_, value) => this.handleField("description", value)}
              />
            </Col>
            <Col xs={12} md>
              <SelectField
                fullWidth
                label="Tipo de Desconto"
                value={type}
                onChange={(_, value) => this.handleField("type", value)}
                options={FilterView.types}
              />
            </Col>
            <Col xs={12} md>
              <SelectField
                fullWidth
                label="Status"
                value={enabled}
                onChange={(_, value) => this.handleField("enabled", value)}
                options={FilterView.status}
              />
            </Col>
          </Row>
        </Loadable>
      </Paper>
    );
  }
}

export default FilterView;



// WEBPACK FOOTER //
// ./src/components/app/registration/discount/list/filter/index.jsx